export const BASE_URL = process.env.REACT_APP_BASE_URL ?? '';
export const API_KEY = process.env.REACT_APP_API_KEY ?? '';
export const AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN ?? '';
export const PROJECT_ID = process.env.REACT_APP_PROJECT_ID ?? '';
export const STORAGE_BUCKET = process.env.REACT_APP_STORAGE_BUCKET ?? '';
export const MESSAGING_SENDER_ID =
  process.env.REACT_APP_MESSAGING_SENDER_ID ?? '';
export const APP_ID = process.env.REACT_APP_APP_ID ?? '';
export const MEASUREMENT_ID = process.env.REACT_APP_MEASUREMENT_ID ?? '';
